module.exports = __webpack_public_path__ + "img/heart_12.509632a7.png";